/* import __COLOCATED_TEMPLATE__ from './auto-write-feedback.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';

/**
 * @param {Action} [onThumbsUpClick] - Action to be fired when thumbs up is clicked
 * @param {Action} [onThumbsDownClick] - Action to be fired when thumbs down is clicked
 */
let AutoWriteFeedback = (_dec = computed('isThumbsUp', 'isThumbsDown'), _class = class AutoWriteFeedback extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isThumbsUp", _descriptor, this);
    _initializerDefineProperty(this, "isThumbsDown", _descriptor2, this);
  }
  get hasBeenSelected() {
    return this.isThumbsUp || this.isThumbsDown;
  }
  thumbClicked(direction) {
    if (this.hasBeenSelected) {
      return;
    }
    if (direction === 'up') {
      this.isThumbsUp = true;
      this.args.onThumbsUpClick?.();
    } else {
      this.isThumbsDown = true;
      this.args.onThumbsDownClick?.();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isThumbsUp", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isThumbsDown", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "hasBeenSelected", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "hasBeenSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "thumbClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "thumbClicked"), _class.prototype), _class);
export { AutoWriteFeedback as default };